import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@utex/ui-kit';
import {
  Sidebar,
  titleStyle,
  Menu,
  Mainbar,
  Container,
  Form,
  FormContent,
  FormFooter,
} from './styles';
import { MobileMenu } from '../../components/MobileMenu';

interface Props {
  menu?: JSX.Element;
  select?: JSX.Element;
  content?: JSX.Element;
  title?: string;
}

export const Layout: React.FC<Props> & {
  Menu: typeof Menu;
  Form: typeof Form;
  FormContent: typeof FormContent;
  FormFooter: typeof FormFooter;
} = (props: Props) => {
  const { t } = useTranslation('deposit');
  const { title = t('Deposit') } = props;
  return (
    <Container>
      <Typography.Title level={2} size={{ all: 'XXL', phonablet: 'XL' }} css={titleStyle}>
        {title}
      </Typography.Title>

      <Box display="flex" flexDirection={{ phonablet: 'column' }} flexGrow={1}>
        {props.menu && props.select && (
          <Sidebar>
            <Box display={{ phonablet: 'none' }}>{props.menu}</Box>
            <Box display={{ tablesktop: 'none' }}>
              <MobileMenu menu={props.menu} currentItem={props.select} />
            </Box>
          </Sidebar>
        )}

        {props.content && <Mainbar>{props.content}</Mainbar>}
      </Box>
    </Container>
  );
};

Layout.Menu = Menu;
Layout.Form = Form;
Layout.FormContent = FormContent;
Layout.FormFooter = FormFooter;
